import axios from 'axios'
import { showError, showNetworkError } from './toastr'
import { tokenDaData } from '../config'
import URL from './url'

const apiCall = ({
                   params,
                 }) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }
  axios.defaults.headers.common.Authorization = tokenDaData

  axios.interceptors.response.use(conf => conf, (error) => {
    if (error.response) {
      try {
        const msg = (error.response.data.errors[0])
          ? error.response.data.errors[0].detail : error.response.data.errors.detail
        showError(msg)
      } catch (e) {
        console.error(e)
      }
    } else {
      showNetworkError()
      throw new Error(error)
    }
  })

  return axios.post(URL.findCity, params, config)
}

export default apiCall
